import { z } from 'zod';

import { buildQueryString } from '../../utils/querystring';
import { makeEndpoint, paginateQuerySchema, paginateResponseSchema } from '../common';

export enum ReportAutomationLogStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export const reportAutomationLogSchema = z.object({
  id: z.string(),
  reportAutomationConfigId: z.string(),
  reportId: z.string().nullable(),
  executedAt: z.string().datetime(),
  status: z.nativeEnum(ReportAutomationLogStatus),
  errorMessage: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

const listReportAutomationLogsQuerySchema = paginateQuerySchema().extend({
  savedConfigId: z.string().optional(),
  status: z.nativeEnum(ReportAutomationLogStatus).optional(),
});

export const ListReportAutomationLogsEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, query }: { brandId: string; query: z.input<typeof listReportAutomationLogsQuerySchema> }) =>
    `v1/brands/${brandId}/report-automation-logs?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(reportAutomationLogSchema),
  requestSchema: z.void(),
  querySchema: listReportAutomationLogsQuerySchema,
});
